import React from 'react';
import Nav from '../Nav/Nav';
import Footer from '../Footer/Footer';
import './AboutUs.css';

const AboutUs = () => {
  return (
    <div className="about-page">
      <div className="rectangle"></div>
      <Nav />
      <div className="about-content">
        <div className="container">
          <h1 className="about-heading">About Quickplanners</h1>
          <div className="about-text">
            <p>
              Quickplanners is an event planning and discovery platform that helps individuals and businesses plan events effortlessly — whether they want to do it themselves, get expert assistance, or hand everything over.
            </p>
            <p>
              We bring together trusted event vendors, verified venues, and experienced planners in one seamless platform. With Quickplanners, you can find and compare vendors, discover venues that fit your needs and budget, or choose a full planning service where professionals manage your event from start to finish.
            </p>
            <p>
              Every vendor and venue on Quickplanners is carefully vetted for quality, reliability, and professionalism, giving you confidence at every stage of planning. From weddings and private celebrations to corporate events and conferences, we simplify the process so you can focus on the moments that matter.
            </p>
            <p>
              Our goal is simple: to remove stress, reduce uncertainty, and make great events easier to plan. Whether you want full control or complete peace of mind, Quickplanners gives you the flexibility to plan your way — with trusted support at every step.
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AboutUs;